<template>
    <div>
        <div class="col-lg-12 mb-4">
            <div class="applicant-nav-tabs">
                <ul class="nav nav-tabs nav-tabs-empl" id="myTab" role="tablist">
                    <li class="nav-item" v-for="(tab,index) in tabs">
                        <a
                            :class="[`nav-link `, {'active': activeTabIndex === index}]"
                            :id="`tab-${index}`"
                            data-toggle="tab"
                            :href="`#${tab}`"
                            role="tab"
                            aria-controls="home"
                            aria-selected="false"
                            @click="setActiveTab(tab)"
                        >
                            {{ tab }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-lg-12 mb-4">
            <div class="box">
                <div class="tab-content" id="myTabContent">

                    <div v-for="(tab,index) in tabs"
                         :class="[`tab-pane fade`, {'show active': activeTabIndex === index}]"
                         :id="tab"
                         role="tabpanel"
                         :aria-labelledby="`tab-${index}`"
                    >
                        <component
                            :changing-password="changingPassword"
                            :list-of-permissions="listOfPermissions"
                            :user-avatar="user.avatar"
                            :is="getComponentName(tab)"
                            :id="user.id"
                            :name="user.name + ' ' + user.last_name "
                            :personal="userPersonal"
                            :user-permissions="userPermissions"
                        ></component>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Personal from "./Tabs/Personal.vue";
import Notifications from "./Tabs/Notifications.vue";
import NotesOnAdmin from "./Tabs/NotesOnAdmin.vue";
import NotesByAdmin from "./Tabs/NotesByAdmin.vue";
import Permissions from "./Tabs/Permissions.vue";
import TabsHandler from "../../../../../resources/js/mixins/TabsHandler";

export default {
    name: 'UserTabsContainer',
    props: {
        user: {
            type: Object,
            required: true,
        },
        listOfPermissions: {
            type: Array,
        },
        viewNotesByAdmin: {
            type: Boolean,
            required: true,
        },
        viewNotesOnAdmin: {
            type: Boolean,
            required: true,
        },
        viewAdminPermissions: {
            type: Boolean,
            required: true,
        },
        changingPassword: {
            type: Boolean,
            required: true,
        },
    },
    components: {
        Personal,
        Notifications,
        Permissions,
        NotesByAdmin,
        NotesOnAdmin,
    },
    data() {
        return {
            userId: null,
            userPermissions: this.user.permissions ?? [],
            userPersonal: {
                avatar: null,
                name: null,
                last_name: null,
                cell_number: null,
                email: null,
                job_title: null,
                status: null,
                password: null,
            },
            selectedTab: null,
            activeTabIndex: 0,
            tabs: []
        }
    },
    methods: {
        getComponentName(tabName) {
                return `${tabName.replace(/\s+/g, '')}`;
        },
        getActiveTab() {

            const urlParams = new URLSearchParams(window.location.search);
            const tab = urlParams.get('tab');

            if (null === tab) {
                return;
            }

            for (let i = 0; i < this.tabs.length; i++) {
                if (this.tabs[i] === tab) {
                    this.activeTabIndex = i;
                }
            }
        },
        setActiveTab(tabName) {
            this.activeTabIndex = this.tabs.indexOf(tabName);
            window.history.pushState({ tab: tabName }, "", `?tab=${tabName}`);
        },

        checkPermissions() {
            const defaultTabs = [
                'Personal',
                'Notifications',
                'Permissions',
                'Notes By Admin',
                'Notes On Admin',];
            let updatedTabs = [...defaultTabs];

            if (!this.viewNotesOnAdmin) {
                updatedTabs = updatedTabs.filter(tab => tab !== 'Notes On Admin');
            }
            if (!this.viewNotesByAdmin) {
                updatedTabs = updatedTabs.filter(tab => tab !== 'Notes By Admin');
            }
            if (!this.viewAdminPermissions) {
                updatedTabs = updatedTabs.filter(tab => tab !== 'Permissions');
            }
            this.tabs = updatedTabs;

            this.getActiveTab();
        },


        setData() {
            Object.keys(this.userPersonal).forEach((key) => {
                if (this.user.hasOwnProperty(key)) {
                    this.userPersonal[key] = this.user[key];
                }
            });
        },
    },
    mounted() {
        this.setData();
        this.checkPermissions()
    }
}

</script>

<style scoped>

</style>
